webpackJsonp([32],{

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

// process.env.NODE_ENV === 'production' ? console.log('Production mode!') : require('__page/index.html');
var mc = __webpack_require__(0);
mc.runVue(['Slider', 'Navigation', 'selectList', 'predictiveSelect']);
mc.runComponents(['rating']);
mc.runFooter();

/***/ })

},[78]);


// WEBPACK FOOTER //
// bundles/basket.bundle.js